import {post, downFile, postfile2} from './http'
import state from "../store/state";
const baseUrl = '/api/capwhale/mktools/mpsign'
// 获取签到首页数据
export const getIndex = v => post(`${baseUrl}/index`, v.data, v.success, v.error, {headers: {EventId: state.eid}})
// 查询名单管理列表
export const getSignNameList = v => post(`${baseUrl}/getSignManagementData`, v.data, v.success, v.error, {headers: {EventId: state.eid}})
// 查询签到数据分析数据
export const getSignData = v => post(`${baseUrl}/getSignData`, v.data, v.success, v.error, {headers: {EventId: state.eid}})
// 获取名单管理和数据分析查询条件数据
export const getSignManagementConditions = v => post(`${baseUrl}/getSignManagementConditions`, v.data, v.success, v.error, {headers: {EventId: state.eid}})
// 导出签到名单数据
export const exportSignList = v => downFile(`${baseUrl}/exportSignManageData`, v.data, v.success, v.error, state.eid)
// 下载名单导入模板
export const downloadSignList = v => downFile(`${baseUrl}/downloadSignemplate`, v.data, v.success, v.error, state.eid)
// 签到名单导入
export const importSignData = v => postfile2(`${baseUrl}/importSignData`, v.data, v.success, v.error, state.eid)
// 签到墙
export const getsignwalldata = v => post(`${baseUrl}/getsignwalldata`, v.data, v.success, v.error, {headers: {EventId: state.eid}})